/**
 * TicketFlow-admin — point d'entrée React.
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * Le `baseUrl` de l'API n'est plus figé : il vient du SERVEUR ACTIF de la liste
 * locale (ORM/SQLite via IPC). `AdminRoot` le résout au démarrage puis l'injecte à
 * l'AuthProvider ; changer de serveur (ServerPicker) rebranche le client.
 */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { AuthProvider } from './ui/AuthProvider';
import { TICKETFLOW_API_CONFIG, TICKETFLOW_TOKEN_KEY, TICKETFLOW_ADMIN_MODE, TICKETFLOW_SITE_LABEL } from './ticketflow/appConfig';
import { getActiveServerUrl } from './ticketflow/servers';
import CentralConsole from './ticketflow/CentralConsole';
import App from './App';
import './index.css';

function AdminRoot() {
  const [baseUrl, setBaseUrl] = useState(null); // null = résolution en cours

  const resolve = useCallback(async () => {
    const url = await getActiveServerUrl(TICKETFLOW_API_CONFIG.baseUrl);
    setBaseUrl(url || TICKETFLOW_API_CONFIG.baseUrl);
  }, []);
  useEffect(() => { resolve(); }, [resolve]);

  const apiConfig = useMemo(() => ({ ...TICKETFLOW_API_CONFIG, baseUrl }), [baseUrl]);

  if (!baseUrl) return <div className="centered"><p className="muted">…</p></div>;

  return (
    <AuthProvider apiConfig={apiConfig} tokenKey={TICKETFLOW_TOKEN_KEY}>
      <App
        onServerChange={resolve}
        centralMode={TICKETFLOW_ADMIN_MODE === 'central'}
        siteLabel={TICKETFLOW_SITE_LABEL}
      />
    </AuthProvider>
  );
}

// L'app hôte INJECTE sa config aux modules neutres.
// Mode CENTRAL (ticket-admin.amia.fr) → CentralConsole (login manager + sites +
// provisioning) ; sinon → admin LAN (AdminRoot).
const Root = TICKETFLOW_ADMIN_MODE === 'central' ? CentralConsole : AdminRoot;
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HashRouter>
      <Root />
    </HashRouter>
  </React.StrictMode>,
);
